<template>
    <span class="text-left">connor_resume.pdf&nbsp;&nbsp;&nbsp;current_position&nbsp;&nbsp;&nbsp;education&nbsp;&nbsp;&nbsp;certificates&nbsp;&nbsp;&nbsp;skills</span>
</template>
